"use client";
import React from "react";
import {
  GoogleMap,
  Libraries,
  Marker,
  useJsApiLoader,
} from "@react-google-maps/api";

export interface GoogleMapsProps {
  lat: number;
  lng: number;
  height: any;
  width: any;
}

const libraries: Libraries = ["places"];

export const GoogleMapComponent = ({
  lat,
  lng,
  height,
  width,
}: GoogleMapsProps) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "",
    libraries,
  });

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ height: height, width: width }}
      center={{ lat: lat, lng: lng }}
      zoom={15}
    >
      <Marker position={{ lat: lat, lng: lng }} />
    </GoogleMap>
  );
};
